module.exports = __webpack_public_path__ + "images/travel.eb5760edfcc2b791ccfc0af649de247d.svg";